import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfs2uw6w59: FaireProductEntity = {
  token: "p_nfs2uw6w59",
  type: "product",
  name: "The Matcha Bowl - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/9329530ed5995a3322085892bddc7c0f5346fa6c07683c3539e3acd0a5be2c38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32442ed99fc33715c548fdd29def08dc9057f83db652b0ccfc4ae558ff9737f4.jpeg",
    "https://cdn.faire.com/fastly/e8afeef42b37e26c3e172a269643b1a7cf291bd5b8e599cc91be02b078534a0a.jpeg",
    "https://cdn.faire.com/fastly/b2c8e77237351f7b534142fccf2a28873a9bf048990f12ed0c241bf86c513c3b.jpeg",
    "https://cdn.faire.com/fastly/f32e5b4b3f8cbcda9c40382e3204b1dd69eaf20ad7589f6a58f6d4dc8be43f3c.jpeg",
    "https://cdn.faire.com/fastly/5f7650d619bbf3602fcf08d89d079dc3a700778bc19b55e6f49f01a18e8264b9.jpeg",
    "https://cdn.faire.com/fastly/63be717b383ab51b033d32a0b8d1730f764eb595900e98cb9b30d02b24e043c0.jpeg"
  ],
  priceDollars: 14.25,
  description: "Traditional Japanese Ceramic Matcha Bowl\n\nWhisk & sip your matcha with bliss! \n\nEnjoy a smooth, perfectly whisked cup of matcha the traditional way with this beautiful ceramic bowl. \n\nJapanese matcha ceremony is all about moving slow, and appreciating the little moments -- starting with your mindful morning cup of tea. Whisk, sip & savour the matcha boost. You deserve it. \n\nHOW TO:\n\n\nIn your matcha bowl, add Lake & Oak Purely Matcha or Mega Matcha powder and a splash of hot (not boiling) water. \n\nTop with hot milk to make a matcha latte. Matcha can be enjoyed right from the bowl, or poured into your fave mug. Sip and bliss out! \n\nCare instructions \n\nDishwasher friendly. \n\n",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:37.239Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
